import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      personelInfo: {
        firstname: 'Prénom',
        lastname: 'Nom',
        birthCountry: 'Pays de Naissance',
        birthCity: 'Ville de Naissance',
        datedenaissance: 'Date de Naissance',
        nationality: 'Nationalité',
        country: 'Pays de résidence',
        city: 'Ville',
        codePostale: 'Code postal',
        profession: 'Profession',
        phone: 'N° de téléphone ',
        email: 'Adresse Email',
        montantTransfert: 'Montant de transfert (€)',
        idAmplitude: 'N° de tiers',
        dateTransfert: 'Date de transfert',
        moyenTransfert: 'Moyen de transfert',
        dateCreation: 'Date de création',
        address: 'Adresse',
        civilite: 'Civilité'
      },
      sourceOfIncome: {
        amountofincome: 'Montant (€)',
        periodicity: 'Périodicité',
        transfervolume: 'Volume de transfert annuel (€)',
        frequency: 'Frequence',
        ibanClient: 'IBAN',
        revenuTranche: 'Tranche de revenu',
        transfertMotif: 'Motif de transfert',
        nationalIdentifier: 'Code fiscale',
        sourceoffunds: 'Provenance des fonds',
        politicallyexposed: 'Politiquement exposé',
        profession: 'Profession',
        activityArea: "Secteur d'activité",
        functionPPE: 'PPE: Fonction exercée',
        luiMemePPE: 'PPE: lui-même',
        relationshipPPE: 'PPE: Lien',
        fullNamePPE: 'PPE : Nom / Prénom',
        ppeEntourage: 'Son entourage',
        ppeLuiMemePPE: 'lui-même'
      },
      beneficiary: {
        iban: 'IBAN',
        codeSwift: 'Code swift',
        banque: 'Nom de la banque',
        relationFamiliale: 'Relation familiale',
        rib: 'RIB',
        lastName: 'Nom',
        firstName: 'Prénom',
        pays: 'Pays de residence',
        numCompteBes: 'Numero de compte amplitude',
        moiMeme: 'Lui même'
      },
      auth: {
        errors: {
          ERR_USER_NOT_FOUND: 'Login ou mot de passe invalide',
          ERR_USER_EMAIL_NOT_FOUND: 'Adresse email invalide',
          ERR_USER_DISABLED:
            'Votre commpte est désactivé, Veuillez contacter votre administrateur!',
          ERR_MDP_EXPIRED: 'Votre mot de passe est expiré, cliquer sur mot de passe oublié',
          LOGIN_ATTEMPTS_EXCEEDED:
            'Nombre de tentatives maximum atteint. Veuillez contacter votre administrateur',
          ERR_TECHNICAL: 'L’application est momentanément inaccessible',
          ERR_USER_INACTIF: 'Votre mot de passe est expiré, cliquer sur mot de passe oublié',
          ERR_EMAIL_NOT_SEND: 'Email non envoyé!',
          update_Pass: 'Erreur lors de la modification du mot de passe',
          VERIFY_OTP_INVALID: 'Code de vérification invalide ou expiré. Veuillez saisir un nouveau code.',
	        VERIFY_OTP_EXPIRED: 'Code de vérification invalide ou expiré. Veuillez saisir un nouveau code.',
          VERIFY_OTP_ATTEMPTS_EXCEEDED: 'Nombre de tentatives maximum atteint. Veuillez réessayer l’authentification'
        },
        success: {
          emailSent:
            'Si cette adresse e-mail a été utilisée pour créer un compte, des instructions pour réinitialiser votre mot de passe vous seront envoyées.'
        }
      },
      unblockUser: {
        alert: {
          message: 'L’utilisateur est bloqué après 3 tentatives de connexion.',
          button: 'Débloquer'
        },
        confirmation: {
          title: 'Débloquer le client',
          message: 'Voulez-vous vraiment débloquer ce client ? Cela ne peut pas être annulé.'
        }
      },
      sendBackDocs: {
        alert: {
          message: 'Certains documents ne sont pas bien envoyés.',
          button: 'Renvoyer les documents sur amplitude '
        }
      },
      expiredToken: "Le lien que vous avez essayé d'atteindre n'est pas valide ou a expiré.",
      uploadDocument: {
        additem: 'Télécharger un nouveau fichier'
      },
      desactivatedAccount: {
        alert: {
          message: 'Si ce compte a été créé par erreur.',
          button: 'Désactiver'
        },
        confirmation: {
          title: 'Désactiver Ce compte',
          message: 'Voulez-vous vraiment désactiver ce compte ? Cela ne peut pas être annulé.'
        }
      }
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
